import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderEdit"><Path d="M2.5 8V3.5H10L12 6.5H21.5V19.5H8" stroke="currentColor"/><Path d="M3.99414 20.2502L2.49414 18.7502L2.49414 12.0068C2.49414 11.1784 3.16571 10.5068 3.99414 10.5068C4.82257 10.5068 5.49414 11.1784 5.49414 12.0068L5.49414 18.7502L3.99414 20.2502Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderEdit;
